// Layout for every route that renders outside `AppShell`: the entry page, the
// MPass login and callback surfaces, role selection, dev login and not-found.
// It exists for two reasons — caiet ACCS-10 requires the support contact on
// *toate paginile web*, and those routes had no footer at all (audit S1,
// spec 002 FR-011); and the gov.md bar the wireframe draws above each of them
// (parity finding A-07, spec 032). It adds nothing else: each page keeps its own
// chrome.
import { Outlet } from 'react-router-dom';
import { Footer } from './Footer';
import { GovBar } from './GovBar';
// The three pages this layout wraps keep their rules here rather than in
// `global.css` (spec 036 NFR-03). The layout is the one place all three pass
// through, so it is where the sheet is pulled in.
import '../../styles/entry-screens.css';

export function PublicShell(): JSX.Element {
  return (
    <div className="simsm-public-shell">
      <GovBar />
      <Outlet />
      <Footer />
    </div>
  );
}
